import { render, staticRenderFns } from "./PhonePreviewMatch.vue?vue&type=template&id=1f27f75f&scoped=true&"
import script from "./PhonePreviewMatch.vue?vue&type=script&lang=js&"
export * from "./PhonePreviewMatch.vue?vue&type=script&lang=js&"
import style0 from "./PhonePreviewMatch.vue?vue&type=style&index=0&id=1f27f75f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f27f75f",
  null
  
)

export default component.exports